const ageFormat = { 0: 'f', 1: 'y' };

const getFormattedAge = age => ageFormat[age] || `${age}yo`;

export default getFormattedAge;



// WEBPACK FOOTER //
// ./src/js/utils/getFormattedAge.js